
if (document.querySelector('.js-popup-open')) {
    const openPopup = () => {
        document.querySelector('.js-compare-popup')?.classList.add('active');
        document.body.classList.add('popup-active');
    };

    const closePopup = () => {
        document.querySelector('.js-compare-popup')?.classList.remove('active');
        document.body.classList.remove('popup-active');
    };

    document.querySelectorAll('.js-popup-open').forEach(element => {
        element.addEventListener('click', openPopup);
    });

    document.querySelectorAll('.js-compare-popup-close').forEach(element => {
        element.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            closePopup();
        }
    });
}
